/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/prefer-ts-expect-error */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-empty-function */
/* eslint-disable no-console */

import { useState, useEffect, useRef } from 'react'
import { Consumer } from '@rails/actioncable'

interface Callbacks {
  received?: (x: any) => void
  initialized?: () => void
  connected?: () => void
  disconnected?: () => void
}

interface Channel {
  identifier: string
  perform: (type: string, payload: any) => void
}

interface ChannelData {
  channel: string
}

interface UseChannel {
  subscribe: (data: ChannelData, callbacks: Callbacks) => void
  unsubscribe: () => void
  send: (type: any, payload: any) => void
}

export default function useChannel(actionCable: Consumer): UseChannel {
  const [connected, setConnected] = useState(false)
  const [subscribed, setSubscribed] = useState(false)
  const channelRef = useRef<Channel | null>(null)

  useEffect(() => {
    return () => {
      unsubscribe()
    }
  }, [])

  const unsubscribe = (): void => {
    setSubscribed(false)
    if (channelRef.current !== null) {
      console.log(`useChannel - INFO: Unsubscribing from ${channelRef.current.identifier}`)
      // @ts-ignore
      actionCable.subscriptions.remove(channelRef.current)
      channelRef.current = null
    }
  }

  // Removed global event listener overrides that were interfering with PhotoSwipe
  // ActionCable should work without these overrides

  const subscribe = (data: ChannelData, callbacks: Callbacks): void => {
    console.log(`useChannel - INFO: Connecting to ${data.channel}`)
    const channel: Channel = actionCable.subscriptions.create(data, {
      received: (x: any) => {
        if (typeof callbacks.received === 'function') {
          callbacks.received(x)
        }
      },
      initialized: () => {
        console.log(`useChannel - INFO: Init ${data.channel}`)
        setSubscribed(true)
        if (typeof callbacks.initialized === 'function') {
          callbacks.initialized()
        }
      },
      connected: () => {
        console.log(`useChannel - INFO: Connected to ${data.channel}`)
        setConnected(true)
        if (typeof callbacks.connected === 'function') {
          callbacks.connected()
        }
      },

      disconnected: () => {
        console.log('useChannel - INFO: Disconnected')
        setConnected(false)
        if (typeof callbacks.disconnected === 'function') {
          callbacks.disconnected()
        }
      }
    })
    channelRef.current = channel
  }

  const send = (type: string, payload: any): void => {
    if (subscribed && !connected) throw new Error('useChannel - ERROR: not connected')
    if (!subscribed) throw new Error('useChannel - ERROR: not subscribed')
    try {
      channelRef.current?.perform(type, payload)
    } catch (e) {
      throw new Error(`useChannel - ERROR: ${e}`)
    }
  }

  return { subscribe, unsubscribe, send }
}
